import type { GpsPoint } from '../../../hooks/useTimesheets';

/**
 * Capture GPS coordinates with a timeout.
 * Returns GpsPoint on success, null on failure or timeout.
 * Never throws.
 */
export async function captureGpsOrNull(timeoutMs = 5000): Promise<GpsPoint | null> {
  if (!navigator.geolocation) return null;

  try {
    const position = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: timeoutMs,
        maximumAge: 30000,
      });
    });

    return {
      lat: position.coords.latitude,
      lon: position.coords.longitude,
      accuracy: position.coords.accuracy,
      capturedAt: new Date().toISOString(),
    };
  } catch {
    return null;
  }
}
